import * as ImageColorizer from './image-colorizer'

export default ImageColorizer

window[ ImageColorizer.ImageColorizerKey ] = ImageColorizer
